/**
 * Code Item references are authored as `018`, `C018` or `Code 018`; all three name the same Code Item.
 * Every reference comparison in the app goes through this normalizer so rule validation, resizing and
 * reference lookups agree on what "the same Code Item" means.
 */
export function normalizeCodeItemReference(value: string | null | undefined): string {
  const normalized = String(value ?? '').trim().replace(/^code\s+/i, '')
  return /^c\d+$/i.test(normalized) ? normalized.slice(1) : normalized
}

/** Display form of a reference: `018` becomes `Code 018`, `Code 018` is left alone. */
export function formatCodeItemReference(value: string | null | undefined): string {
  const reference = String(value ?? '').trim()
  if (!reference) return ''
  return /^code\s+/i.test(reference) ? reference : `Code ${reference}`
}
